import React from 'react'
import { withStyles } from '@mui/styles'
import Box from "@mui/material/Box"
import { CARD } from "../../modules/constants"

const styles = theme => ({
  card: {
    flex: 1,
    display: CARD.ENVELOPE.DISPLAY, // "flex",    
    // backgroundColor: CARD.CONTAINER.BACKGROUND_COLOR,
  },
})

const DataCard = ({ classes, children, portrait, marginTop, marginLeft, showCard }) => 
  <Box
    id="data-card" 
    className={classes.card}
    style={{
      flexFlow: portrait ? "column" : "row",
      margin: showCard && !portrait ? CARD.MARGIN : 0,
      // boxShadow: showCard && !portrait ? CARD.SHADOW : null,
      borderRadius: showCard && !portrait ? CARD.RADIUS : 0,
      border: showCard && !portrait ? CARD.BORDER: null,
      backgroundColor: CARD.BACKGROUND_COLOR,
  }}
  >
    {children}
  </Box>

export default withStyles(styles)(DataCard)